import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import {
  fetchDataEngine,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  allEmployeeLeaveBalances,
  employeeLeaveBalances,
  getStructuredLeaveApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
  LeaveApplicationsColumns,
  LeaveBalancesColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import LeaveBalanceForm from "./LeaveBalanceForm";
import { tokens } from "../../../theme";
import { useTheme } from "@emotion/react";

const base_url = HRService.uri;

const LeaveBalancesTable = () => {
  const actions = {
    entity: "Leave Balances",
    isSubRight: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
      inputObjectName: "updateEmployeeLeaveBalance",
      InputObject: "EmployeeLeaveBalance",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
      inputObjectName: "createCaseDynamic",
      InputObject: "newCase",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
    AssignTask: {
      key: "ASSIGN_TASK",
      button_name: "Assign Task",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewRelievers: {
      key: "MARK_TASK_DONE",
      button_name: "View Relievers",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    approve: {
      key: "APPROVE_LEAVE",
      button_name: "Approve Leave",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    decline: {
      key: "REJECT_LEAVE",
      button_name: "Reject Leave",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    // Custom approval configs
    // dataObject: {
    //   inputObjectName: "approveDeclineLeaveApplication",
    //   inputSubObjectName: "applicationsApprovals",
    //   inputFields: ["applicationId", "userId", "comments"],
    // },

    // Config used by generic form submission (DynamicForm inside Modal)
    submit: {
      inputObjectName: "updateEmployeeLeaveBalance",
      inputSubObjectName: "employeeLeaveBalance",
    },

    actionName: "Leave Balance", // Changed for clearer notifications
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="2px">
      <DynamicTable
        title="Leave Balances"
        subtitle="View all Leave Balances For All Employees"
        columns={LeaveBalancesColumns}
        FormComponent={LeaveBalanceForm}
        query={allEmployeeLeaveBalances}
        actions={actions}
        base_url={base_url}
      />
    </Box>
  );
};

export default LeaveBalancesTable;
